// extracted by css-extract-rspack-plugin
export default {"Skeleton":"d1oZx","shimmer":"LvPIT"};